var classes = {
  "root": "m_f11b401e",
  "header": "m_5a7c2c9",
  "content": "m_b8a05bbd",
  "inner": "m_31cd769a"
};
export { classes as default };